import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const patientAgeReport = {
    path: '/patientAgeReport',
    component: Layout,
    name: 'patientAgeReport',
    redirect: '/patientAgeReport/index',
    children: [{
      path: '/patientAgeReport/index',
      component: () => import('@/views/patientAgeReport/index'),
      name: 'patientAgeReport.index',
      meta: {
        title: i18n.t(`message.patient_ages`)
      }
    }, ]
  }
  

export default patientAgeReport